
import { serializable, alias, object, list, primitive } from 'serializr';

export class InAppNotification {

	@serializable(alias('id', primitive()))
	id?: string;

	@serializable(alias('event', primitive()))
	event?: string;

	@serializable(alias('title', primitive()))
	title?: string;

	@serializable(alias('message', primitive()))
	message?: string;

	@serializable(alias('is_read', primitive()))
	isRead?: boolean;

	@serializable(alias('createdAt', primitive()))
	createdAt?: string;

	@serializable(alias('variables', primitive()))
	variables?: string;

}